export default async function dateNumberFormatter(cell) {
    let isNumeric = parseFloat(cell);
    // console.log("dateNumberFormatter" + isNumeric);
    if (isNumeric.toString() === "NaN") {
        return "0";
    } else {
        return "" + parseFloat(cell)
    }
}